import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import * as styles from './LinkList.module.scss'
import { Icon } from '@iconify/react'
// import WorkspaceIcon from "../../../UI/WorkspaceIcons/WorkspaceIcon"

import TrainingIcon from './../../../../images/icons/capabilities/Training.inline.svg'
import IntlProgramSupportIcon from './../../../../images/icons/capabilities/IntlProgramSupport.inline.svg'
import SecurityIcon from './../../../../images/icons/capabilities/Security.inline.svg'
import ModelBasedSysEngrIcon from './../../../../images/icons/capabilities/ModelBasedSysEngr.inline.svg'
import ElectronicWarfareIcon from './../../../../images/icons/capabilities/ElectronicWarfare.inline.svg'
import TechServicesIcon from './../../../../images/icons/capabilities/TechServices.inline.svg'
import IntegrateProductSupportIcon from './../../../../images/icons/capabilities/IntegrateProductSupport.inline.svg'
import ProgramManagementIcon from './../../../../images/icons/capabilities/ProgramManagement.inline.svg'
import InfoTechIcon from './../../../../images/icons/capabilities/InfoTech.inline.svg'
import AdvancedEngineeringIcon from './../../../../images/icons/capabilities/AdvancedEngineering.inline.svg'
import SoftwareSolutionsIcon from './../../../../images/icons/capabilities/SoftwareSolutions.inline.svg'

const ServicesLinkList = () => {
  return (
    <Fragment>
      <div>
        {/* <h4>Services</h4> */}
        <ul className={`${styles.navlist} ${styles.services_linksList}`}>
          <li>
            <Link to="/program-management">
              <ProgramManagementIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Program Management</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/training">
              <TrainingIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Training</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/electronic-warfare">
              <ElectronicWarfareIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Electronic Warfare</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/advanced-engineering">
              <AdvancedEngineeringIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Advanced Engineering</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/software-solutions">
              <SoftwareSolutionsIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="28"
                width="32"
              />
              <span>Software Solutions</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/technical-services">
              <TechServicesIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Technical Services</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/product-support">
              <IntegrateProductSupportIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Integrated Product Support</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/program-support">
              <IntlProgramSupportIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="40"
                width="40"
              />
              <span>International Program Support</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/model-based-systems-engineering">
              <ModelBasedSysEngrIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="40"
                width="40"
              />
              <span>Model Based Systems Engineering</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/information-technology">
              <InfoTechIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Information Technology</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li>
            <Link to="/security">
              <SecurityIcon
                className={`${styles.serviceIcon__mainNav}`}
                height="32"
                width="32"
              />
              <span>Security</span>
              <Icon
                className={`${styles.dropdownArrow__icon}`}
                icon="eva:arrow-ios-forward-fill"
                inline={true}
              />
            </Link>
          </li>
          <li></li>
        </ul>
      </div>
      {/* Workspaces */}
      {/* <div>
                <h4 className={styles.mobileHeader}>Workspaces</h4>
                <ul className={`${styles.navlist} ${styles.workspaces_linksList}`}>
                    <li><Link to='/'>
                        <WorkspaceIcon color='blue' type='conference' format='solid' />
                        Conference Centers
                        <Icon icon="eva:arrow-forward-fill" inline={true} width="18" height="18" vAlign='center'/></Link></li>
                    <li><Link to='/'>
                        <WorkspaceIcon color='blue' type='training' format='solid' />
                        Traning Centers
                        <Icon icon="eva:arrow-forward-fill" inline={true} width="18" height="18" vAlign='center'/></Link></li>
                </ul>
            </div> */}
    </Fragment>
  )
}
export default ServicesLinkList
